var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_25614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 0.666664C3.94663 0.666664 0.666626 3.94666 0.666626 8C0.666626 12.0533 3.94663 15.3333 7.99996 15.3333C12.0533 15.3333 15.3333 12.0533 15.3333 8C15.3333 3.94666 12.0533 0.666664 7.99996 0.666664ZM10.2866 11.6667H3.99996L5.71329 9.66666H12L10.2866 11.6667ZM5.71329 9L3.99996 7H10.2866L12 9H5.71329ZM10.2866 6.33333H3.99996L5.71329 4.33333H12L10.2866 6.33333Z",
    fill: "#0D1615"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_25614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.0957b9528e9193e34fb6e1ecd645b070.svg";
export { ForwardRef as ReactComponent };